import Lineup from "./class/Lineup";
import Drawer from "./class/Drawer";
import Popup from "./class/Popup";
import $ from "jquery";
// import "slick-carousel";
import "youtube-iframe";
// import autoprefixer from "autoprefixer";

jQuery(function($) {
  if ($('.swiper-youtube-container').length > 0) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    var ytplayer = [];
    // 3. This function creates an <iframe> (and YouTube player)

    var initPlayer = function(element) {
      var player = element.querySelector('.video-iframe');
      var button = element.querySelector('.video-play');
      ytplayer = new YT.Player(player, {
          playerVars: {
              autoplay: 0,
              enablejsapi: 1,
              modestbranding: 1,
              controls: 0,
              rel: 0,
              loop: 1,
              infinite: true,
              videoId: element.dataset.id,
          playlist: element.dataset.id,
          },
          
      });

      button.addEventListener('click', function() {
          console.log(ytplayer);
          console.log(ytplayer.getPlayerState());
          ytplayer.playVideo();
          switch (ytplayer.getPlayerState()) {
              case 1:
                  ytplayer.stopVideo();
                  break;
              default:
                  ytplayer.playVideo();
                  break;
          }
      });
    };

    var swiper_youtube = new Swiper('.swiper-youtube-container', {
      autoplay: {
        delay: 300000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        reverseDirection: false
      },
      centeredSlides: false,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      origin: location.protocol + '//' + location.hostname + "/",
      breakpoints: {
        640: {
          centeredSlides: true,
          slidesPerView: 1.5,
          spaceBetween: 50,
        },
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    }).on('slideChange', function() {
      
      var slideWrapper = $(".swiper-container");
      // スクロール位置を取得
      let scrollTop = $(window).scrollTop();
      let scrollBtm = scrollTop + $(window).height();
      // 対象要素の位置を取得
      let targetTop = slideWrapper.offset().top;
      let targetBtm = targetTop + slideWrapper.height();
      // console.log(ytplayer.getPlayerState())
      // console.log(YT.PlayerState.PLAYING)
        var isVideo = swiper_youtube.slides[swiper_youtube.previousIndex].querySelector('.video-container');
        if (isVideo) {
            YT.get(isVideo.querySelector('iframe').id).stopVideo();
            // console.log(isVideo.querySelector('iframe').id);
            YT.PlayerState.PLAYING = 2;
        }

        var activeVideo = swiper_youtube.slides[swiper_youtube.activeIndex].querySelector('.video-container');
        if (activeVideo && (scrollBtm > targetTop && scrollTop < targetBtm)) {
          YT.get(activeVideo.querySelector('iframe').id).playVideo();
          YT.PlayerState.PLAYING = 1;
        }

        $(window).on('load scroll', function() {
          var slideWrapper = $(".swiper-container");
          // スクロール位置を取得
          let scrollTop = $(window).scrollTop();
          let scrollBtm = scrollTop + $(window).height();
          // 対象要素の位置を取得
          let targetTop = slideWrapper.offset().top;
          let targetBtm = targetTop + slideWrapper.height();
          if(scrollBtm > targetTop && scrollTop < targetBtm) {
             if (YT.PlayerState.PLAYING = 2) {
              return;
            }
            var activeVideo = swiper_youtube.slides[swiper_youtube.activeIndex].querySelector('.video-container');
            if (activeVideo) {
              YT.get(activeVideo.querySelector('iframe').id).playVideo();
              YT.PlayerState.PLAYING = 1;
              // console.log(ytplayer.getPlayerState())
            }
          }
          if (!(scrollBtm > targetTop) || !(scrollTop < targetBtm)) {
            var activeVideo = swiper_youtube.slides[swiper_youtube.activeIndex].querySelector('.video-container');
            if (activeVideo) {
              YT.get(activeVideo.querySelector('iframe').id).stopVideo();
              YT.PlayerState.PLAYING = 2;
            }
            return;
          }
        })
    });

    window.onYouTubePlayerAPIReady = function() {
      var slideWrapper = $(".swiper-container");
      // スクロール位置を取得
      let scrollTop = $(window).scrollTop();
      let scrollBtm = scrollTop + $(window).height();
      // 対象要素の位置を取得
      let targetTop = slideWrapper.offset().top;
      let targetBtm = targetTop + slideWrapper.height();
      if(scrollBtm > targetTop && scrollTop < targetBtm) {
        // console.log("OOOOOOOOO");
       
        // console.log(YT.PlayerState.PLAYING);
        var container = document.querySelectorAll('.video-container');
        for (var i = 0; i < container.length; i++) {
          initPlayer(container[i])
          YT.PlayerState.PLAYING = 1;
        }
      }
    };
  }

  $(window).on('load scroll', function() {
    var slideWrapper = $(".swiper-container");
    // スクロール位置を取得
    let scrollTop = $(window).scrollTop();
    let scrollBtm = scrollTop + $(window).height();
    // 対象要素の位置を取得
    let targetTop = slideWrapper.offset().top;
    let targetBtm = targetTop + slideWrapper.height();
    if(scrollBtm > targetTop && scrollTop < targetBtm) {
      var activeVideo = swiper_youtube.slides[swiper_youtube.activeIndex].querySelector('.video-container');
      // console.log(YT.PlayerState.PLAYING);
      // console.log(YT.PlayerState.PLAYING);
      // if (YT.PlayerState.PLAYING = 2) { //画面内きたら再生つまり画面内で停止中に縦スクロールしたらしたら再生される
      //   // console.log("aaa");
      //   // YT.get(activeVideo.querySelector('iframe').id).playVideo();
      //   // YT.PlayerState.PLAYING = 1;
      //   return;
      // } 
        var activeVideo = swiper_youtube.slides[swiper_youtube.activeIndex].querySelector('.video-container');
        if (activeVideo.querySelector('iframe') == null) {
          onYouTubePlayerAPIReady()
          // YT.get(activeVideo.querySelector('iframe').id).playVideo();
          // YT.PlayerState.PLAYING = 1;
        } else {

          // console.log(activeVideo.querySelector('iframe').id);
          // YT.get(activeVideo.querySelector('iframe').id).playVideo();
          // // onYouTubePlayerAPIReady()
          // YT.PlayerState.PLAYING = 1;
        }
      // }

    }
  
    if (!(scrollBtm > targetTop) || !(scrollTop < targetBtm)) {
      var activeVideo = swiper_youtube.slides[swiper_youtube.activeIndex].querySelector('.video-container');
      if (activeVideo) {
        if (activeVideo.querySelector('iframe')) {
          YT.get(activeVideo.querySelector('iframe').id).stopVideo();
          YT.PlayerState.PLAYING = 2;
        }
      }
      return;
    }
  })
});

const drawer = new Drawer();
drawer.init();

$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    //ヘッダーの高さを取得
    var header = $('header').height();
    //ヘッダーの高さを引く
    var position = target.offset().top - header;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

/* FadeIn animation */
const blockFadeIn = document.querySelectorAll(".blockArea--fadeIn");
let FadeHeight = null;
const scrollFadeIn = () => {
  blockFadeIn.forEach((item) => {
    let elPosition = item.offsetTop;
    let scrollPosition = window.scrollY;
    let innerHeight = window.innerHeight;
    if (scrollPosition > elPosition - innerHeight + FadeHeight) {
      item.classList.add("scrollIn");
    }
  });
};
scrollFadeIn();

window.addEventListener("scroll", function () {
  scrollFadeIn();
});
